import { Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Button from "components/Forms/CustomButtons/ButtonTS";
import React from "react";
import { useTranslation } from "react-i18next";

interface ConfirmDeleteModalProps {
  modalOpen: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ConfirmReopenModal({
  modalOpen,
  onClose,
  onConfirm,
  isDeleting,
}: ConfirmDeleteModalProps) {
  const { t } = useTranslation("modals");

  return (
    <Dialog
      open={modalOpen}
      fullWidth
      maxWidth="sm"
      scroll="body"
      onClose={onClose}
      disableBackdropClick
    >
      <DialogTitle>
        {t("reopen-activity")}
        <Button
          justIcon
          simple
          color="tumblr"
          round
          size="sm"
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
          }}
          onClick={onClose}
        >
          <Close />
        </Button>
      </DialogTitle>

      <DialogActions>
        <Button disabled={isDeleting} color="tumblr" simple onClick={onClose}>
          {t("cancel")}
        </Button>

        <Button disabled={isDeleting} color="danger" onClick={onConfirm}>
          {t("reopen")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
